import type {SVGProps} from 'react'
const ChevronDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 1000 1000"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M499.99,692.69l350.01-350.02-35.36-35.36-314.65,314.66L185.35,307.33l-35.35,35.35,349.99,350h0Z" />
  </svg>
)
export {ChevronDownIcon}
